export default function isPayAccountInGoodStanding(accountStatus) {
  if (!accountStatus?.length) {
    return false;
  }
  return ['ready_to_transact'].includes(accountStatus);
}
